<script lang="ts">
  import { tenantCtx } from '../../../lib/tenant.svelte';
  import { effectiveOrgTipo } from '../../../lib/org-context.svelte';
  import VetClinicDashboard from './VetClinicDashboard.svelte';
  import OpticaClinicDashboard from './OpticaClinicDashboard.svelte';
  import ClinicaMedicaDashboard from './ClinicaMedicaDashboard.svelte';

  let { onNavigate }: { onNavigate: (tab: string) => void } = $props();

  const org = $derived(
    effectiveOrgTipo(tenantCtx.orgTipo as import('../../../lib/navigation').OrgTipo | null, tenantCtx.isHospitalEdition),
  );
</script>

{#key org ?? 'default'}
  {#if org === 'clinica-veterinaria'}
    <VetClinicDashboard {onNavigate} />
  {:else if org === 'clinica-optica'}
    <OpticaClinicDashboard {onNavigate} />
  {:else}
    <ClinicaMedicaDashboard {onNavigate} org={org ?? 'clinica-medica'} />
  {/if}
{/key}
